import { useState } from "react";
import { loginRequest } from "../authConfig";
import { callMsGraph } from "../graph";
import { useMsal } from "@azure/msal-react";
import { ProfileData } from "./ProfileData";
import { Button, Spinner } from "react-bootstrap";

/**
 * Renders information about the signed-in user or a button to retrieve data about the user
 */
export const ProfileContent = () => {
    const { instance, accounts } = useMsal();
    const [ graphData, setGraphData ] = useState(null);

    if (!graphData) {
        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        }).then((response) => {
            callMsGraph(response.accessToken).then(response => setGraphData(response));
        });
    }

    return (
        <>
            {graphData?
            <ProfileData graphData={graphData} /> : 
            <div className="text-center p-2">
                <span><Spinner animation="border" variant="success" /> Loading...</span>
            </div>
            }
        </>
    );
};